import React from 'react'

export const LogoLetter = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='69'
      height='78'
      viewBox='0 0 69 78'
      fill='none'
    >
      <path
        d='M21.1293 56.3878C15.3588 56.289 9.58827 56.116 3.81775 56.1654C0.944868 56.1901 -0.070529 55.1276 0.00376953 52.2613C0.177133 46.1333 -0.120067 40.0053 0.152361 33.8774C0.226659 31.9994 1.09348 29.7509 2.38132 28.4165C10.9257 19.6199 19.6186 10.9469 28.4354 2.42206C29.7727 1.11246 32.0512 0.148782 33.9087 0.124072C44.3352 -0.0983138 54.7866 0.0993648 65.2379 0.000526434C67.9127 -0.0241831 69.0519 0.815942 68.9529 3.58342C68.8043 8.22882 68.7795 12.8989 68.9529 17.5443C69.0767 20.4106 67.8384 21.0778 65.2379 21.0531C55.1581 20.9543 45.0782 21.0037 35.0231 21.0037C26.0578 21.0037 21.0798 25.9703 21.0798 34.7916C21.0798 42.0315 21.0303 49.2467 20.9807 56.4866L21.1046 56.3631L21.1293 56.3878Z'
        fill='url(#paint0_linear_164_746)'
      />
      <path
        d='M21.0059 56.5116C35.4941 56.5116 49.9823 56.6105 64.4705 56.4622C67.7644 56.4375 69.2009 57.2035 68.978 60.7617C68.7055 65.16 68.8541 69.583 68.978 73.9813C69.0275 76.3781 68.3836 77.5889 65.6841 77.5642C52.0626 77.4654 38.4165 77.4901 24.7951 77.5642C22.2194 77.5642 21.4021 76.5264 21.4269 74.0307C21.4764 68.1745 21.2783 62.2937 21.1792 56.4375L21.0554 56.561L21.0059 56.5116Z'
        fill='url(#paint1_linear_164_746)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_164_746'
          x1='0.00376948'
          y1='28.2683'
          x2='68.9776'
          y2='28.2683'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#0583F2' />
          <stop offset='1' stop-color='#0554F2' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_164_746'
          x1='21.0059'
          y1='66.9885'
          x2='69.0027'
          y2='66.9885'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#0583F2' />
          <stop offset='1' stop-color='#0554F2' />
        </linearGradient>
      </defs>
    </svg>
  )
}
